import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://127.0.0.1:5000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Добавляем интерсептор для автоматического добавления токена
apiClient.interceptors.request.use((config) => {
  const url = config.url || '';
  
  // Для /auth/refresh НЕ добавляем access_token - там используется refresh_token
  // который передаётся явно в headers запроса
  if (!url.includes('/auth/refresh')) {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  
  // Добавляем текущую организацию
  const orgId = localStorage.getItem('org_id');
  if (orgId) {
    config.headers['X-Organization-Id'] = orgId;
  }
  return config;
});

// Координация обновления токена, чтобы избежать штормов запросов
let isRefreshing = false;
let refreshSubscribers = [];

function onTokenRefreshed(newToken) {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
}

function addRefreshSubscriber(callback) {
  refreshSubscribers.push(callback);
}

// Добавляем интерцептор для автоматического обновления токена при 401
apiClient.interceptors.response.use(
  (response) => {
    // Унифицируем ответы с серверной пагинацией
    // Если тело имеет форму { data: [...], page, pages, ... }
    const respBody = response.data;
    if (respBody && Array.isArray(respBody.data)) {
      // Сохраняем пагинацию отдельно
      response.pagination = {
        page: respBody.page,
        pages: respBody.pages,
        per_page: respBody.per_page,
        total: respBody.total,
        total_pages: respBody.total_pages,
      };

      // Для обратной совместимости подменяем response.data списком элементов
      // Это позволит существующему коду, который ожидает массив, продолжать работать
      response.data = respBody.data;

      // Дополнительно эмитируем старые заголовки, если их ждёт код
      if (response.headers) {
        response.headers['x-total-count'] = String(respBody.total ?? '');
        response.headers['x-page'] = String(respBody.page ?? '');
        response.headers['x-per-page'] = String(respBody.per_page ?? '');
        response.headers['x-total-pages'] = String(respBody.total_pages ?? '');
        if (
          respBody.page != null &&
          respBody.per_page != null &&
          respBody.total != null
        ) {
          const hasNextCalc = respBody.page * respBody.per_page < respBody.total;
          response.headers['x-has-next'] = hasNextCalc ? 'true' : 'false';
        }
      }
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config || {};
    const requestUrl = originalRequest.url || '';

    // Не пытаемся рефрешить сам запрос /auth/refresh
    if (requestUrl.includes('/auth/refresh')) {
      return Promise.reject(error);
    }

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        if (isRefreshing) {
          // Ждем завершения текущего рефреша
          return new Promise((resolve, reject) => {
            addRefreshSubscriber((newToken) => {
              if (!newToken) {
                return reject(error);
              }
              originalRequest.headers = originalRequest.headers || {};
              originalRequest.headers.Authorization = `Bearer ${newToken}`;
              resolve(apiClient(originalRequest));
            });
          });
        }

        isRefreshing = true;
        try {
          console.log('[Auth] Attempting token refresh...');
          // Запрашиваем новый access по refresh
          const resp = await apiClient.post('/auth/refresh', {}, { headers: { Authorization: `Bearer ${refreshToken}` } });
          const newToken = resp.data.access_token;
          const newRefresh = resp.data.refresh_token;
          console.log('[Auth] Token refresh successful');
          // Сохраняем новый токен
          localStorage.setItem('access_token', newToken);
          if (newRefresh) {
            localStorage.setItem('refresh_token', newRefresh);
          }
          onTokenRefreshed(newToken);
          isRefreshing = false;
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return apiClient(originalRequest);
        } catch (refreshError) {
          console.error('[Auth] Token refresh failed:', refreshError.response?.status, refreshError.response?.data || refreshError.message);
          isRefreshing = false;
          onTokenRefreshed(null);
          // Если не удалось обновить, убираем токены и редирект на логин
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/auth';
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export const api = apiClient;
export default apiClient; 